import { ActionReducerMap } from '@ngrx/store';
import { heartbeatReducer } from '@components/heartbeat/heartbeat.reducer';
import { heartbeatKey } from '@components/heartbeat/heartbeat.state';
import { keyboardReducer } from '@components/keyboard/keyboard.reducer';
import { keyboardKey } from '@components/keyboard/keyboard.state';
import { assistantChatReducer } from '@pages/assistant/chat/chat.reducer';
import { reportActiveHealthGuidelineReducer } from '@pages/report/active/health-guideline/health-guideline.reducer';
import { reportActiveHealthGuidelineKey } from '@pages/report/active/health-guideline/health-guideline.state';
import { analyticReducer } from '../components/analytic/analytic.reducer';
import { analyticKey } from '../components/analytic/analytic.state';
import { authReducer } from '../components/auth/auth.reducer';
import { authKey } from '../components/auth/auth.state';
import { avatarDisplayReducer } from '../components/avatar/display/avatar-display.reducer';
import { avatarDisplayKey } from '../components/avatar/display/avatar-display.state';
import { dnaReportAvatarReducer } from '../components/avatar/dna-report-avatar/dna-report-avatar.reducer';
import { dnaReportAvatarKey } from '../components/avatar/dna-report-avatar/dna-report-avatar.state';
import { avatarNotificationModalReducer } from '../components/avatar/notification-modal/notification-modal.reducer';
import { avatarNotificationModalKey } from '../components/avatar/notification-modal/notification-modal.state';
import { productUnlockReducer } from '../components/home/product/unlock/unlock.reducer';
import { productUnlockKey } from '../components/home/product/unlock/unlock.state';
import { reminderReducer } from '../components/reminder/reminder.reducer';
import { reminderKey } from '../components/reminder/reminder.state';
import { assistantChatKey } from './assistant/chat/chat.state';
import { assistantSubscriptionReducer } from './assistant/subscription/subscription.reducer';
import { assistantSubscriptionKey } from './assistant/subscription/subscription.state';
import { avatarCreateReducer } from './avatar/create/create.reducer';
import { avatarCreateKey } from './avatar/create/create.state';
import { dailyActivityReducer } from './daily/activity/activity.reducer';
import { dailyActivityKey } from './daily/activity/activity.state';
import { dailyJournalReducer } from './daily/journal/journal.reducer';
import { dailyJournalKey } from './daily/journal/journal.state';
import { homeMyHealthPassportHealthRecordReducer } from './home-v3/my-health-passport/health-record/health-record.reducer';
import { homeMyHealthPassportHealthRecordKey } from './home-v3/my-health-passport/health-record/health-record.state';
import { homeMyRecommendationGeneralHealthReducer } from './home-v3/my-recommendation/general-health/general-health.reducer';
import { homeMyRecommendationGeneralHealthKey } from './home-v3/my-recommendation/general-health/general-health.state';
import { ocrReducer } from './lwb/medical/ocr/ocr.reducer';
import { ocrKey } from './lwb/medical/ocr/ocr.state';
import { lwbPeriscopeReducer } from './lwb/periscope/periscope.reducer';
import { lwbPeriscopeKey } from './lwb/periscope/periscope.state';
import { prodigyHealthGuidelineReducer } from './prodigy/health-guideline/health-guideline.reducer';
import { prodigyHealthGuidelineKey } from './prodigy/health-guideline/health-guideline.state';
import { prodigyReducer } from './prodigy/prodigy.reducer';
import { prodigyKey } from './prodigy/prodigy.state';
import { notificationProfileSwitchReducer } from './profile/notification-profile-switch/notification-profile-switch.reducer';
import { notificationProfileSwitchKey } from './profile/notification-profile-switch/notification-profile-switch.state';
import { profileQuestionnaireReducer } from './profile/questionnaire/questionnaire.reducer';
import { profileQuestionnaireKey } from './profile/questionnaire/questionnaire.state';
import { questionnaireActiveReducer } from './questionnaire/active/active.reducer';
import { questionnaireActiveKey } from './questionnaire/active/active.state';
import { questionnaireGeneralReducer } from './questionnaire/general/general.reducer';
import { questionnaireGeneralKey } from './questionnaire/general/general.state';
import { questionnaireNourishReducer } from './questionnaire/nourish/nourish.reducer';
import { questionnaireNourishKey } from './questionnaire/nourish/nourish.state';
import { questionnaireQuickAccessModalReducer } from './questionnaire/quick-access-modal/quick-access-modal.reducer';
import { questionnaireQuickAccessModalKey } from './questionnaire/quick-access-modal/quick-access-modal.state';
import { questionnaireTenxReducer } from './questionnaire/tenx/tenx.reducer';
import { questionnaireTenxKey } from './questionnaire/tenx/tenx.state';
import { reportAncestryReducer } from './report/ancestry/ancestry.reducer';
import { reportAncestryKey } from './report/ancestry/ancestry.state';
import { nutritionGuideReducer } from './report/nourish/nutrition-guide/nutrition-guide.reducer';
import { nutritionGuideKey } from './report/nourish/nutrition-guide/nutrition-guide.state';
import { recalculateReducer } from './report/nourish/recalculate/recalculate.reducer';
import { recalculateKey } from './report/nourish/recalculate/recalculate.state';
import { oncoriskReducer } from './report/oncorisk/oncorisk.reducer';
import { oncoriskKey } from './report/oncorisk/oncorisk.state';
import { ReportPersonaHealthGuidelineReducer } from './report/persona/health-guideline/health-guideline.reducer';
import { reportPersonaHealthGuidelineKey } from './report/persona/health-guideline/health-guideline.state';
import { reportReducer } from './report/report.reducer';
import { reportKey } from './report/report.state';
import { reportSkinHealthGuidelineAnalysisReducer } from './report/skin/health-guideline/analysis/analysis.reducer';
import { reportSkinHealthGuidelineAnalysisKey } from './report/skin/health-guideline/analysis/analysis.state';
import { reportSkinHealthGuidelineReducer } from './report/skin/health-guideline/health-guideline.reducer';
import { reportSkinHealthGuidelineKey } from './report/skin/health-guideline/health-guideline.state';
import { reportSkinHealthGuidelineTakePictureReducer } from './report/skin/health-guideline/take-picture/take-picture.reducer';
import { reportSkinHealthGuidelineTakePictureKey } from './report/skin/health-guideline/take-picture/take-picture.state';
import { reportViewSearchReducer } from './report/view/search/search.reducer';
import { reportViewSearchKey } from './report/view/search/search.state';
import { reportViewTraitResultReducer } from './report/view/trait/result/result.reducer';
import { reportViewTraitResultKey } from './report/view/trait/result/result.state';
import { reportViewTraitReducer } from './report/view/trait/trait.reducer';
import { reportViewTraitKey } from './report/view/trait/trait.state';
import { reportViewReducer } from './report/view/view.reducer';
import { reportViewKey } from './report/view/view.state';
import { shopCatalogReducer } from './shop/catalog/catalog.reducer';
import { shopCatalogKey } from './shop/catalog/catalog.state';
import { shopOrderReducer } from './shop/order/order.reducer';
import { shopOrderKey } from './shop/order/order.state';
import { trackerReducer } from './tracker/reducers/tracker.reducer';
import { trackerKey } from './tracker/tracker.state';

export const reducers: ActionReducerMap<any> = {
  [analyticKey]: analyticReducer,
  [authKey]: authReducer,
  [avatarNotificationModalKey]: avatarNotificationModalReducer,
  [avatarDisplayKey]: avatarDisplayReducer,
  [dnaReportAvatarKey]: dnaReportAvatarReducer,
  [avatarCreateKey]: avatarCreateReducer,
  [dailyJournalKey]: dailyJournalReducer,
  [dailyActivityKey]: dailyActivityReducer,
  [heartbeatKey]: heartbeatReducer,
  [homeMyHealthPassportHealthRecordKey]:
    homeMyHealthPassportHealthRecordReducer,
  [homeMyRecommendationGeneralHealthKey]:
    homeMyRecommendationGeneralHealthReducer,
  [keyboardKey]: keyboardReducer,
  [lwbPeriscopeKey]: lwbPeriscopeReducer,
  [ocrKey]: ocrReducer,
  [prodigyKey]: prodigyReducer,
  [prodigyHealthGuidelineKey]: prodigyHealthGuidelineReducer,
  [profileQuestionnaireKey]: profileQuestionnaireReducer,
  [productUnlockKey]: productUnlockReducer,
  [reminderKey]: reminderReducer,
  [reportKey]: reportReducer,
  [reportAncestryKey]: reportAncestryReducer,
  [reportViewKey]: reportViewReducer,
  [reportViewTraitKey]: reportViewTraitReducer,
  [reportViewTraitResultKey]: reportViewTraitResultReducer,
  [reportViewSearchKey]: reportViewSearchReducer,
  [reportPersonaHealthGuidelineKey]: ReportPersonaHealthGuidelineReducer,
  [reportSkinHealthGuidelineKey]: reportSkinHealthGuidelineReducer,
  [reportSkinHealthGuidelineTakePictureKey]:
    reportSkinHealthGuidelineTakePictureReducer,
  [reportSkinHealthGuidelineAnalysisKey]:
    reportSkinHealthGuidelineAnalysisReducer,
  [shopOrderKey]: shopOrderReducer,
  [trackerKey]: trackerReducer,
  [questionnaireNourishKey]: questionnaireNourishReducer,
  [questionnaireTenxKey]: questionnaireTenxReducer,
  [questionnaireActiveKey]: questionnaireActiveReducer,
  [questionnaireGeneralKey]: questionnaireGeneralReducer,
  [questionnaireQuickAccessModalKey]: questionnaireQuickAccessModalReducer,
  [reportActiveHealthGuidelineKey]: reportActiveHealthGuidelineReducer,
  [assistantChatKey]: assistantChatReducer,
  [assistantSubscriptionKey]: assistantSubscriptionReducer,
  [nutritionGuideKey]: nutritionGuideReducer,
  [recalculateKey]: recalculateReducer,
  [shopCatalogKey]: shopCatalogReducer,
  [oncoriskKey]: oncoriskReducer,
  [notificationProfileSwitchKey]: notificationProfileSwitchReducer
};
